<template>
  <component
    class="c-title"
    :is="`h${size}`"
  >
    <k-icon
      v-if="icon"
      class="icon"
      :icon="icon"
      :size="iconSize"
    />
    <span class="text">
      <slot />
    </span>
  </component>
</template>

<script>
import { KIcon } from 'kaledo-components'
export default {
  components: {
    KIcon
  },
  props: {
    size: {
      type: [String, Number],
      default: 1
    },
    icon: String,
    iconSize: {
      type: String,
      default: '20'
    }
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

// Bar settings
$c-title-bar-size: 90px 3px;
$c-title-bar-color: $secondary-color-placeholder;
$c-title-bar-color: var(--color-secondary);

// Icon settings
$c-title-icon-color: $icon-color;

// Text settings
$c-title-text-color: $title-color;
$c-title-text-font-size: 16px;
$c-title-text-font-weight: 500;
$c-title-text-font-family: $title-font-family;

.c-title {
  margin: 0;
  line-height: 1;
  font-size: 0;

  & > .text {
    font-size: $c-title-text-font-size;
    font-weight: $c-title-text-font-weight;
    font-family: $c-title-text-font-family;
    color: $c-title-text-color;
  }

  & > .icon {
    margin-right: 10px;
    vertical-align: bottom;
    color: $c-title-icon-color;
    &.-bookmark {
      margin-right: 1px
    }
  }

  &::after {
    @include size($c-title-bar-size);
    display: block;
    margin-top: 8px;
    border-radius: 3px;
    background-color: $c-title-bar-color;
    content: '';
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CComponents/CTitle.vue